<template>
  <div>
    <Select v-model="selected"
            :remote-method="searchQuote"
            :loading="loading"
            @on-change="handleValueChanged"
            :disabled="disabled"
            remote
            filterable
            clearable>
      <Option v-for="q in results" :key="q.id" :value="q.id" :label="q.title + ' (' + q.number + ')'"></Option>
    </Select>
    <div v-if="selected && !loading" class="text-align-right" style="font-size: 12px; color: rgb(128, 134, 149);"><a :href="quoteLink" target="_blank">{{ $t('order.quote_reference_desc') }}</a></div>
  </div>
</template>

<script>
import { eloquentsearch } from '@/api/search'
export default {
  name: 'QuoteSelect',
  props: {
    disabled: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      selected: this.$attrs.value,
      results: [],
      loading: false
    }
  },
  computed: {
    quoteLink () {
      if (this.selected) {
        const path = this.$router.resolve({ name: 'menu.quote.edit', params: { quoteId: this.selected } })
        return path.href
      }
    }
  },
  methods: {
    searchQuote (query) {
      this.loading = true
      eloquentsearch('quote', query)
        .then(resp => {
          this.results = resp.data.data
        })
        .finally(() => {
          this.loading = false
        })
    },
    handleValueChanged (value) {
      const quoteInfo = _.find(this.results, { id: value })
      this.$emit('input', value)
      this.$emit('update:quote', quoteInfo)
    }
  }
}
</script>
